<template>
	<form
		id="production-form"
		:action="this.production ? this.production['@id'] : '/api/productions'"
		method="POST"
		:axiosMethod="this.production ? 'patch' : 'post'"
		ref="mainForm">
		<CRow alignHorizontal="center">
			<CCol sm="6">
				<vc-date-picker v-model="date" :model-config="modelConfig" :masks="masks" mode="date">
					<template v-slot="{ inputValue, inputEvents }">
						<div role="group" class="form-group">
							<label for="prod-date">Choisissez la date </label>
							<div class="input-group">
								<input type="hidden" name="at" :value="inputValue" />
								<input
									id="prod-date"
									type="text"
									class="form-control"
									:value="$moment(inputValue).format('DD/MM/YYYY')"
									v-on="inputEvents" />
								<div class="input-group-append">
									<span class="input-group-text">
										<CIcon name="cil-calendar" />
									</span>
								</div>
								<small class="form-text text-muted w-100">Exemple: 06/12/2021 09:57</small>
							</div>
						</div>
					</template>
				</vc-date-picker>
				<CSelect
					name="flight"
					v-model="flightIri"
					label="Choisissez la LTA"
					placeholder="Sélectionnez..."
					description="Choissisez d'abord une date pour avoir la liste des LTA disponibles"
					:options="flightOptions"
					ref="flight"
					:value.sync="flightIri"
					required />
				<transition name="fade">
					<div v-show="loaded">
						<CSelect
							name="pallet"
							v-model="palletIri"
							label="Choisissez la palette"
							placeholder="Sélectionnez..."
							:options="palletOptions"
							ref="pallet"
							description="Choissisez d'abord une LTA pour avoir la liste des palettes associées à celle-ci"
							:value.sync="palletIri"
							required />
					</div>
				</transition>
			</CCol>
		</CRow>
		<CRow alignHorizontal="center">
			<CCol sm="6">
				<CRow alignHorizontal="end">
					<CButton
						:color="isProductionClosed ? 'danger' : 'success'"
						:disabled="isSubmitDisabled"
						v-on:click="onSubmit($refs.mainForm)"
						style="margin-right: 15px">
						<span style="vertical-align: middle; margin-right: 5px">Valider</span
						><CIcon name="cil-check-alt" />
					</CButton>
				</CRow>
			</CCol>
		</CRow>
	</form>
</template>

<script>
	export default {
		props: {
			step: Number,
		},
		computed: {
			isSubmitDisabled() {
				if (this.date === '' || this.date === null) {
					return true;
				}

				if (this.flightIri === '' || this.flightIri === null) {
					return true;
				}

				if (this.palletIri === '' || this.palletIri === null) {
					return true;
				}

				if (this.isProductionClosed) {
					return true;
				}

				return false;
			},
			isProductionClosed() {
				return this.production && this.production.state === 'production.closed';
			},
		},
		data() {
			return {
				masks: {
					input: 'YYYY-MM-DD',
				},
				modelConfig: {
					type: 'string',
				},
				loaded: false,
				production: null,
				flights: [],
				flightIri: null,
				flight: null,
				flightOptions: [],
				palletIri: null,
				palletOptions: [],
				date: this.$moment().format('YYYY-MM-DD'),
			};
		},
		watch: {
			date: function () {
				this.getFlights();
			},
			flightIri: function (newVal) {
				// Reset loaded data
				this.loaded = false;
				this.production = null;

				this.flight = this.flights.find(item => item['@id'] === newVal);
				this.getFlightPallets();
			},
			flight: function (newVal) {
				if (newVal && newVal.production) {
					this.getProduction(newVal.production);
				} else {
					this.loaded = true;
				}
			},
			production: function (newVal) {
				if (newVal) {
					this.palletIri = this.production.pallet['@id'];
				}
			},
		},
		methods: {
			getFlights() {
				const from = this.$moment(this.date).format('YYYY-MM-DD 00:00');
				const to = this.$moment(this.date)
					.set({ hour: 23, minute: 59, second: 59 })
					.format('YYYY-MM-DD HH:mm');

				this.$axios
					.get(`/api/flights?departureTime[after]=${from}&departureTime[before]=${to}`)
					.then(res => {
						if (res.status === 200) {
							const flights = res.data['hydra:member'];
							this.flights = res.data['hydra:member'];
							this.flightOptions = [];
							this.flightOptions = flights.map(item => {
								return {
									label: item.LTA,
									value: item['@id'],
								};
							});
						} else {
							this.$toast.error(
								"Une erreur s'est produite, certaines fonctionnalitées " +
									'peuvent ne pas fonctionner correctement, contactez un administrateur'
							);
						}
					});
			},
			getFlightPallets() {
				this.$axios.get(`${this.flightIri}/pallets?state=pallet.pending`).then(res => {
					if (res.status === 200) {
						const pallets = res.data['hydra:member'];
						this.palletOptions = [];
						this.palletOptions = pallets.map(item => {
							return {
								label: item.reference,
								value: item['@id'],
							};
						});
					} else {
						this.$toast.error(
							"Une erreur s'est produite, certaines fonctionnalitées " +
								'peuvent ne pas fonctionner correctement, contactez un administrateur'
						);
					}
				});
			},
			getProduction(iri) {
				this.$axios.get(iri).then(res => {
					if (res.status === 200) {
						this.production = res.data;
						this.loaded = true;

						if (this.production.state === 'production.closed') {
							this.$toast.error('Cette production est clôturé, impossible de la relancer');
						}
					} else {
						this.$toast.error(
							"Une erreur s'est produite, certaines fonctionnalitées " +
								'peuvent ne pas fonctionner correctement, contactez un administrateur'
						);
					}
				});
			},
			onSubmit(form) {
				if (this.isSubmitDisabled) {
					return;
				}

				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$emit('submit', res.data);
					} else {
						this.$toast.error(res.data['hydra:description']);
					}
				});
			},
		},
		mounted() {
			this.getFlights();
		},
	};
</script>
<style>
	.btn-success.disabled,
	.btn-success:disabled {
		cursor: not-allowed;
	}
</style>
